"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prop = function (property) {
  return function (obj) {
    return obj.hasOwnProperty(property) ? obj[property] : false;
  };
};
exports.propExists = function (property) {
  return function (obj) {
    return obj.hasOwnProperty(property);
  };
};
exports.propsExist = function () {
  var properties = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    properties[_i] = arguments[_i];
  }
  return function (obj) {
    return properties.map(function (x) {
      return exports.propExists(x)(obj);
    }).filter(function (x) {
      return x === true;
    }).length > 0;
  };
};
exports.immutableKeyDelete = function (keys) {
  return function (obj) {
    var clone = Object.assign({}, obj);
    for (var index = 0; index < keys.length; index++) {
      if (clone.hasOwnProperty(keys[index])) {
        delete clone[keys[index]];
      }
    }
    return clone;
  };
};
exports.findDiff = function (a) {
  return function (b) {
    var diff = {};
    var isFirstObjBigger = Object.keys(a).length >= Object.keys(b).length;
    // Set larger object as base for comparison
    var baseObj = isFirstObjBigger ? a : b;
    var otherObj = isFirstObjBigger ? b : a;
    // Check each key for differing values, set keys on diff
    Object.keys(baseObj).forEach(function (key) {
      if (baseObj[key] !== otherObj[key]) {
        diff[key] = true;
      }
    });
    // Double-check that otherObj doesn't have different keys
    // that we might have skipped, if so, set them on diff
    Object.keys(otherObj).forEach(function (key) {
      if (!exports.propExists(key)(baseObj)) {
        diff[key] = true;
      }
    });
    return diff;
  };
};